// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"0ed85817","184":"49537604","268":"761647ac","579":"4273f0ae","708":"39353377","747":"cd9839e1"}[chunkId] + ".chunk.js";
};